import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { FaSpinner } from "react-icons/fa";
import config from "../../config";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";
import RichTextEditor from "../RichTextEditor";

const RecipeVideo = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [restaurant, setRestaurant] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [subCategory, setSubCategory] = useState([]);

  const axiosAPI = useAxios();

  const [formData, setFormData] = useState({
    name: "",
    sub_category_id: "",
    video_id: "",
    is_active_or_inactive_status: "",
  });

  function removeFormData() {
    setFormData({
      name: "",
      sub_category_id: "",
      video_id: "",
      is_active_or_inactive_status: "",
    });
  }

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  async function fetchRestaurant() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/recipe/video?page=${page}`);
      setRestaurant(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      setRestaurant([]);
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  async function fetchSubCategory(id) {
    try {
      const response = await axiosAPI.get(`/api/v1/all-subcategories`);
      setSubCategory(response?.data?.subcategories);
    } catch (error) {
      console.error("Error fetching category:", error);

      setSubCategory([]);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    const payload = {
      recipe_name: formData.name,
      sub_category_id: formData.sub_category_id,
      subCategory_id: formData.sub_category_id,
      video_id: formData.video_id,
    };

    try {
      let response;

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/recipe/video/${currentUserId}`,
          payload
        );

        window.notifyMessage(
          "Success",
          "Restaurant details updated successfully",
          "success"
        );
      } else {
        response = await axiosAPI.post(`/api/recipe/video`, payload);

        window.notifyMessage(
          "Success",
          "Restaurant details added successfully",
          "success"
        );
      }

      hideModal("newUserModal");
      removeFormData();
      fetchRestaurant(); // refresh list
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "There was an error!";
      window.notifyMessage("Error", errorMsg, "danger");
    } finally {
      setLoading(false); // Stop loading in all cases
    }
  };

  const openEditModal = (restaurantId) => {
    setIsEditMode(true);
    showModal("newUserModal");
    setCurrentUserId(restaurantId);

    // Use a different variable name in the callback
    const productToEdit = restaurant.find(
      (restaurant) => restaurant.id === restaurantId
    );

    console.log("Id", productToEdit);

    setFormData({
      name: productToEdit?.recipe_name || "",
      sub_category_id:
        productToEdit?.sub_category_id || productToEdit?.subCategory_id || "",
      video_id: productToEdit?.video_id || "",
    });
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/recipe/video/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchRestaurant();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  async function changeRestaurantStatus(e, restaurantId) {
    const currentStatus = e.target.value;

    // console.log("product  Id", blogId);
    // console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the product card status?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/recipe/video/change-restaurant-status/${restaurantId}`,
        { status: currentStatus }
      );

      fetchRestaurant();
      window.notifyMessage(
        "Success",
        "Restaurant status changed successfully",
        "success"
      );
    } catch (error) {
      console.error("Error changing product status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change restaurant status. Please try again.",
        "danger"
      );
    }
  }

  function openMediaLibraryModal() {
    showModal("customModal");
  }

  function handleMediaSumbit() {
    // console.log("Media Ids", formData.mediaIds);
    hideModal("customModal");
  }
  function openBlogModal() {
    showModal("newUserModal");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  useEffect(() => {
    fetchSubCategory();
  }, []);

  useEffect(() => {
    fetchRestaurant();
  }, [page]);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openBlogModal()}
            >
              Add Recipe Video
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Recipe Video" : "Add Recipe Video"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/*Restaurant Name */}
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter recipe name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Restaurant phone number */}
                  <div className="mb-3">
                    <label htmlFor="video_id" className="form-label">
                      Video Id
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="video_id"
                      placeholder="Enter video id"
                      value={formData.video_id}
                      onChange={handleChange}
                      required
                    ></input>
                  </div>

                  {/* Sub Category Id */}
                  <div className="mb-3">
                    <label htmlFor="sub_category_id" className="form-label">
                      Sub Category
                    </label>
                    <select
                      className="form-select"
                      id="sub_category_id"
                      value={formData.sub_category_id}
                      onChange={handleChange}
                    >
                      <option value="">Select Sub Category</option>
                      {subCategory &&
                        subCategory?.map((subCategory) => (
                          <option key={subCategory?.id} value={subCategory?.id}>
                            {subCategory?.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary  btn-sm"
                    disabled={loading}
                  >
                    {loading ? (
                      <FaSpinner className="spinner" spin />
                    ) : isEditMode ? (
                      "Update Recipe Video"
                    ) : (
                      "Add Recipe Video"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* restaurant Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Recipe Videos ({restaurant?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr no</th>
                        <th>Name</th>
                        <th>Video Id</th>
                        <th>Sub Category</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : restaurant?.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Recipes found.
                          </td>
                        </tr>
                      ) : (
                        restaurant &&
                        restaurant?.map((restaurant, index) => (
                          <tr key={restaurant.id}>
                            <td>{index + 1}</td>
                            <td>{restaurant?.recipe_name}</td>
                            <td>{restaurant?.video_id}</td>
                            <td>
                              {subCategory?.find(
                                (sub) =>
                                  String(sub?.id) ===
                                  String(
                                    restaurant?.sub_category_id ||
                                      restaurant?.subCategory_id
                                  )
                              )?.name ||
                                restaurant?.sub_category_id ||
                                restaurant?.subCategory_id ||
                                "-"}
                            </td>

                            <td>
                              <select
                                className="form-select"
                                value={restaurant.is_active_or_inactive}
                                onChange={(e) =>
                                  changeRestaurantStatus(e, restaurant?.id)
                                }
                              >
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                              </select>
                            </td>
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() => openEditModal(restaurant.id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(restaurant.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipeVideo;
